import { all, call, Effect, fork, put, takeLatest } from 'redux-saga/effects';
import { environment } from '../../config';
import { standardiseError } from '../../utils/error';
import { clearCurrentOrganisationAction } from '../organisation/actions';
import {
  clearAuthenticatedUserAction,
  clearAuthenticatedUserDoneAction,
  getAuthenticatedUserAction,
  setAuthenticatedUserAction,
  setAuthenticatedUserErrorAction,
} from './actions';
import { getLegacyAuthenticatedUser, Response } from './api';

export function* handleGetAuthenticatedUser(): Generator<Effect> {
  try {
    const { data } = (yield call(getLegacyAuthenticatedUser)) as Response;
    yield put(setAuthenticatedUserAction({ user: data }));
  } catch (e) {
    if (environment === 'development' || environment === 'test') {
      console.error('handleGetCurrentUser() error', e);
    }
    const error = standardiseError(e);
    yield put(setAuthenticatedUserErrorAction({ error }));
  }
}

function* watchGetAuthenticatedUser() {
  yield takeLatest(getAuthenticatedUserAction, handleGetAuthenticatedUser);
}

export function* handleClearAuthenticatedUser(): Generator<Effect> {
  yield put(clearCurrentOrganisationAction());
  yield put(clearAuthenticatedUserDoneAction());
}

function* watchClearAuthenticatedUser() {
  yield takeLatest(clearAuthenticatedUserAction, handleClearAuthenticatedUser);
}

export function* authenticatedUserSagas(): Generator<Effect> {
  yield all([fork(watchGetAuthenticatedUser), fork(watchClearAuthenticatedUser)]);
}
